export default __webpack_public_path__ + "static/api-a1433325c070a03c03ea5ba1d4396b25.svg";